export default {
    intro: '초성, 뜻, 예문 등의 단서를 보고<br />어떤 단어인지 추리해보세요!',
    word: '단어',
    meaning: '뜻',
    example: '예',
    resources: '자료',
    teacherFooter: {
        left: '왼쪽 문항에서 단어를 선택해 주세요.',
    },
    emptyExample: '예문이 없습니다.',
    openExample: '예문 공개시 단어가 전체 공개 됩니다.',
    introSelectWord: '왼쪽 단어를 선택해서 시작해주세요!',
    subExamplesExpand: '보조 예문 더보기',
    subExamplesCollapse: '접기',
    showInitial: '초성 보여주기',
    showAll: '전체 보여주기',
    show: '보여주기',
    table: {
        question: '문제',
        emptyMessage: '내용이 없어요.',
    },
    teacher: {
        modal: {
            clearConfirm: {
                title: '대기 어휘를 모두 비울까요?',
                message: '등록 대기 중인 어휘가 모두 삭제됩니다. 계속하시겠습니까?',
            },
            closeConfirm: {
                title: '입력한 문항을 삭제할까요?',
                message: '닫으면 대기열의 어휘가 모두 사라집니다. 계속하시겠습니까?',
            },
            questionDelete: {
                title: '문항을 삭제할까요?',
                // {word}: 삭제 대상 문항의 표제어. 활동에서 영구 제거됨을 안내.
                message: "'{word}' 문항이 활동에서 삭제됩니다. 계속하시겠습니까?",
            },
            waitItemDelete: {
                title: '대기 어휘를 삭제할까요?',
                // {word}: 삭제 대상 대기 어휘. 대기열에서만 제거되며 활동에는 영향 없음을 안내.
                message: "'{word}'을(를) 대기열에서 삭제합니다. 계속하시겠습니까?",
            },
            // {count}: BE가 사전 중복으로 건너뛴 어휘 수
            duplicateNotice: '이미 등록된 어휘 {count}개는 추가되지 않았습니다.',
            // {count}: 뜻이 없어 등록 불가로 건너뛴 어휘 수
            skippedNotice: '뜻이 비어 있어 {count}개 어휘가 등록되지 않았습니다.',
            // 혼합(뜻없는 어휘 + 뜻있는 어휘) 등록 시 확인 모달
            mixedEmptyConfirm: {
                title: '등록할까요?',
                // {empty}: 뜻 비어 등록 불가 개수
                line1: '뜻이 비어 있는 어휘 {empty}개는 추가되지 않습니다.',
                // {valid}: 실제 등록될 개수
                line2: '나머지 {valid}개만 활동에 등록할까요?',
            },
            // 뜻없는 어휘만 있을 때 등록 불가 안내
            onlyEmptyNotice: {
                title: '등록할 수 없습니다',
                message: '등록할 수 있는 어휘가 없어요. 뜻이 비어 있는 어휘만 남아 있습니다.',
            },
            registerFailed: '등록에 실패했습니다.',
        },
    },
};
